import fetch from "@/fetch";

// 获取订单详情数据
export const getOrderDetail = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/todaysnapshot/getorderdetail",
    data: params
  });
};
